import type { ColumnId } from "../types/confirmations.types";

export const CONFIRMATION_COLUMNS: { id: ColumnId; label: string }[] = [
  { id: "pending", label: "Pendientes" },
  { id: "confirmed", label: "Confirmados" },
];

export const COLUMN_PENDING: ColumnId = "pending";
export const COLUMN_CONFIRMED: ColumnId = "confirmed";

export const CONFIRMATIONS_API_ENDPOINTS = {
  CONFIRMATIONS: "/internal/operations/confirmations",
  confirmationById: (id: string) =>
    `/internal/operations/confirmations/${id}`,
  attachmentPresignedUrl: (id: string) =>
    `/internal/operations/confirmations/${id}/attachment-presigned-url`,
  history: (id: string) => `/internal/operations/confirmations/${id}/history`,
  status: (id: string) =>
    `/internal/operations/confirmations/${id}/status`,
  take: (id: string) =>
    `/internal/operations/confirmations/${id}/take`,
  attachment: (id: string) =>
    `internal/operations/confirmations/${id}/attachment`,
  takerReminder: (id: string) =>
    `/internal/operations/notifications/reminders/confirmations/${encodeURIComponent(id)}`,
} as const;

export const CONFIRMATIONS_PAGE_SIZE = 25;
